/* ============================================================================
   BUNDLE PAGE — the parts of set.html that change with the bundle (?set=):
   the name, price and crumbs, the set toggles, the triptych's product cards,
   Why You'll Love This and its REVIEWS link, and the bundle's own story
   (editorial) and Shop the Look, where it has them. Everything else on the
   page is the PDP's own modules, fed the bundle as PRODUCT.

   Below the fold follows Figma 1594:89620 (SITE WORKSHOP slide 23): a card
   per product, then Fabric; Why You'll Love This; the story; Head to Toe.

   The toggles are the live kit page's Straight-Leg / Jogger / Wide-Leg Set
   switch: links to the sibling set, as on wearfigs.com (each set is its own
   page there), carrying the colour across when the sibling has it. A bundle
   without siblings (the Espresso Set) shows none.
   ========================================================================== */

import { $, $$ } from './mo.js';
import { SET_TOGGLES, money } from './data.js';
import { tm } from './ui.js';

const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
const count = (n) => n.toLocaleString('en-US');

/* the triptych's product card (Figma 1594:89626) — the Fit card's layout:
   the product's name, its lines flush left, then DETAILS into its Product
   Details */
const productCard = (c, img) => `
  <article class="pdp-tri__card pdp-tri__card--product" aria-labelledby="tri-${c.id}" data-reveal data-tri-card>
    <div class="pdp-tri__media" aria-hidden="true">
      <img class="pdp-tri__img" src="${img}" alt="" loading="lazy" decoding="async">
    </div>
    <div class="pdp-tri__content" data-tri-content>
      <h2 class="pdp-tri__title" id="tri-${c.id}">${c.shortName}</h2>
      <div class="pdp-tri__split pdp-tri__split--fit">
        <p class="pdp-tri__col">${c.card.join('<br>')}<br><br><button class="pdp-tri__switch" type="button" aria-haspopup="dialog" data-tri-details="${c.id}">Details<span class="u-sr">: ${esc(c.plainName)}</span></button></p>
      </div>
    </div>
  </article>`;

/* the bundle's story — Product - Editorial Gallery (1594:89620): the large
   plate with its callouts, three cards and the line beside them */
const storyHTML = (st) => `
  <figure class="pdp-edit__large" data-reveal data-edit-large>
    <img class="pdp-edit__large-img" src="${st.large.src}" alt="${esc(st.large.alt)}" loading="lazy" decoding="async">
    ${st.large.callouts.map((c) => `<span class="pdp-edit__callout" style="${['left', 'right', 'top'].filter((k) => k in c).map((k) => `${k}:${c[k]}%`).join(';')}" aria-hidden="true">${c.text}</span>`).join('')}
  </figure>
  <div class="pdp-edit__col pdp-edit__col--b">
    ${st.cards.slice(0, 2).map((c, i) => editCard(c, 'ab'[i])).join('')}
  </div>
  <div class="pdp-edit__col pdp-edit__col--c">
    ${editCard(st.cards[2], 'c')}
    <p class="pdp-edit__story trim" data-reveal data-edit-item>${st.text}</p>
  </div>`;
const editCard = (c, k) => `
  <figure class="pdp-edit__card pdp-edit__card--${k}" data-reveal data-edit-item>
    <span class="pdp-edit__card-media"><img class="pdp-edit__card-img" src="${c.anim || c.src}" alt="${esc(c.alt)}" loading="lazy" decoding="async"${c.anim ? ` data-anim data-src-still="${c.src}"` : ''}></span>
    <figcaption class="pdp-edit__label trim">${c.label}</figcaption>
  </figure>`;

export function renderBundle(kit, { color }) {
  document.title = `10 · PDP prototype · ${kit.name} — FIGS Motion Lab`;
  $('.pdp-hero').setAttribute('aria-label', kit.name);
  $('.pdp-crumbs__product').textContent = kit.name;
  $('[data-gallery-track]').setAttribute('aria-label', `${kit.name} product images`);
  $('.pdp-title__name').textContent = kit.name;
  $('.pdp-title__price').textContent = money(kit.price);
  $('[data-fav]').setAttribute('aria-label', `Save ${kit.name} to favorites`);
  /* what's in the bundle — the Product Form's opening line (1678:96985) */
  $('.pdp-form__desc').innerHTML = tm(kit.contents);

  /* set toggles */
  const toggles = $('[data-set-toggles]');
  if (kit.toggles) {
    toggles.innerHTML = SET_TOGGLES.map((t) => `
      <a class="pdp-set" href="?set=${t.id}" data-set="${t.id}"${t.id === kit.id ? ' aria-current="page"' : ''} data-press>${t.label}</a>`).join('');
    syncToggles(color);
  } else toggles.remove();

  /* triptych: a card per product, then the PDP's Fabric card */
  const tri = $('[data-tri]');
  $('.pdp-tri__card--fabric', tri).insertAdjacentHTML('beforebegin', kit.components.map((c) => productCard(c, kit.tri[c.id])).join(''));
  tri.dataset.count = String(kit.components.length + 1);

  /* why you'll love this — the kit page's description; REVIEWS counts its products' */
  $('[data-love-copy]').innerHTML = tm(kit.description);
  if (kit.cta) $('[data-love-cta] .trim').textContent = kit.cta;
  const rv = $('[data-open-reviews]');
  $('.pdp-reviews__score', rv).textContent = `4.9(${count(kit.reviews)})`;
  rv.setAttribute('aria-label', `Reviews: 4.9 out of 5, ${count(kit.reviews)} reviews of the ${kit.components.map((c) => c.shortName).join(', ').replace(/, ([^,]*)$/, ' and $1')}`);

  /* the story and Head to Toe — only a bundle with its own photography */
  const story = $('[data-edit]');
  if (kit.story) {
    story.setAttribute('aria-label', kit.story.label);
    story.innerHTML = storyHTML(kit.story);
  } else story.remove();
  const stl = $('[data-stl]');
  if (kit.look) {
    $('[data-stl-title-rest]', stl).textContent = ` ${kit.look.title}`;
    const img = $('.pdp-stl__look-img', stl);
    img.src = kit.look.image;
    img.alt = kit.look.alt;
  } else stl.remove();
}

/* the toggles carry the page's colour to the sibling set */
export function syncToggles(color) {
  $$('[data-set]').forEach((a) => { a.href = `?set=${a.dataset.set}&color=${color}`; });
}
